<template>
	<footer class="footer_sec">
		<div class="pc_footer">
			<div class="footer_up">
				<div class="container-box">
					<ul class="nav-list">
						<li class="nav-item dropdown">
							<a
								class="nav-link dropdown-toggle active"
								href="#"
								id="navbarDropdown"
								role="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								{{
									$t(
										'new_ui.components.header_component.navigation.individual.label',
									)
								}}
							</a>
							<ul class="dropdown-menu" aria-labelledby="navbarDropdown">
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/online_shopping',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.online_shopping',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/offline_kiosk',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.offline_kiosk',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/qr',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.pay_with_qr',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/trade_and_cashback',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.transaction_cashback',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/send',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.send_asset',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/receive',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.asset_request',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/deposit',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.get_deposit',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/commission',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.fee',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/wallet',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.wallet',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/account',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.account',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/sale',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.sell',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/exchange',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.exchanging_currency',
											)
										}}</a
									>
								</li>
							</ul>
						</li>
						<li class="nav-item dropdown">
							<a
								class="nav-link dropdown-toggle"
								href="#"
								id="navbarDropdown"
								role="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								{{
									$t(
										'new_ui.components.header_component.navigation.business.label',
									)
								}}
							</a>
							<ul class="dropdown-menu" aria-labelledby="navbarDropdown">
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/start',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.getting_Started',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/receive',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.accepting_payment',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/pay',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.make_a_payment',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/risk',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.risk_management',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/corps',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.about_company',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/platform',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.platforms_features',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/pay',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.payment_method',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/global',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.global_payment',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/pay',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.processing',
											)
										}}</a
									>
								</li>
							</ul>
						</li>

						<li>
							<a
								class="dropdown-item"
								href="javascript:void(0)"
								v-on:click="
									$router.push({
										path: '/development/main',
									})
								"
								>{{
									$t(
										'new_ui.components.header_component.navigation.development.label',
									)
								}}</a
							>
						</li>

						<li class="nav-item">
							<a
								class="nav-link"
								:href="$router.resolve({ name: 'cs' }).href"
								>{{
									$t(
										'new_ui.components.header_component.navigation.customer_service.label',
									)
								}}</a
							>
						</li>
					</ul>
				</div>
			</div>
			<div class="footer_dwn">
				<div class="container-box">
					<div class="footer_inn">
						<img
							:style="isMobile ? { width: '107px' } : { width: '200px' }"
							:src="img.logoGray"
							:alt="
								$t('new_ui.components.footer_component.accessibility.logo_alt')
							"
						/>
						<div class="terms_footer">
							<ul>
								<li>
									<a
										class="nav-link"
										@click="showAboutAlert"
										href="javascript:void(0)"
										>About</a
									>
								</li>
								<li>
									<a
										class="nav-link"
										:href="$router.resolve({ name: 'franchaise' }).href"
										>Privacy</a
									>
								</li>
								<li>
									<a
										class="nav-link"
										:href="$router.resolve({ name: 'cookies' }).href"
										>Cookies</a
									>
								</li>
							</ul>
						</div>

						<div class="footer_lt">
							<p>
								<img
									:src="img.iconMail"
									:alt="
										$t('new_ui.components.footer_component.connect.email.alt')
									"
								/>
								<a href="mailto:support@jpworldpay.com">{{
									$t('new_ui.components.footer_component.connect.email.support')
								}}</a>
							</p>
							<p>
								<img
									:src="img.iconMail"
									:alt="
										$t('new_ui.components.footer_component.connect.email.alt')
									"
								/>
								<a href="mailto:support@jpworldpay.com">{{
									$t('new_ui.components.footer_component.connect.email.info')
								}}</a>
							</p>
						</div>
						<p class="copyright">
							{{ $t('new_ui.components.footer_component.copyright.text') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import footerlogo from '@/assets/images/sub/footerlogo_white.png';
import phncall from '@/assets/images/sub/Call.png';
import whtsp from '@/assets/images/sub/WhatsApp.png';
import mail from '@/assets/images/sub/Mail.png';
import logoGray from '@/assets/images/v2/logo-gray.svg';
import iconMail from '@/assets/images/v2/icon/icon-mail.svg';

export default {
	data: () => ({
		mobile: window.innerWidth <= 768,
		img: {
			image26: footerlogo,
			image27: phncall,
			image28: whtsp,
			image29: mail,
			image30: mail,
			logoGray: logoGray,
			iconMail: iconMail,
		},
	}),

	name: 'Footer',
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		showAboutAlert() {
			alert('Coming soon.');
		},
	},
};
</script>
